import { render, staticRenderFns } from "./all-employee-insurances.vue?vue&type=template&id=22e78d38"
import script from "./all-employee-insurances.vue?vue&type=script&lang=js"
export * from "./all-employee-insurances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports